import React, { useState, useCallback } from 'react';
// import { StaticImage } from 'gatsby-plugin-image';

import Layout from '../components/Layout';
import SEO from '../components/SEO';
import TabHeaderBlock from '../components/TabHeaderBlock';
import TabSidebarBlock from '../components/TabSidebarBlock';
import { PopupBlock } from '../styles/PopupBlock';
import { WhiteBlock } from '../styles/WhiteBlock';

const Advertising = () => {
  const [warningPopup, setWarningPopup] = useState(false);
  const warningPopupclick = useCallback((value) => (e) => {
    if (e) e.preventDefault();
    setWarningPopup((state) => (state === value ? null : value));
  });
  return (
    <Layout>
      <SEO title="Home" />
      <div className="db-area-main">
        <div className="db-container">
          <a href="#!" className="db-back-link button-chevron-left">
            <img src="/img/chevron-left.svg" alt="chevron" /> Back to the
            dashboard
          </a>

          <h1 className="db-heading">
            Dribbble Workspace{' '}
            <img
              src="/img/chevron-down.svg"
              alt="chevron"
              style={{ width: 23, opacity: 0.4 }}
            />
          </h1>

          <TabHeaderBlock />

          <div className="db-tab-content-block">
            <div className="flex-row">
              <div className="col sidebar-col">
                <TabSidebarBlock />
              </div>

              <div className="col right-block-col">
                <WhiteBlock>
                  <h2 className="white-block-head">Advertising</h2>

                  <div className="white-block-body">
                    <div className="flex-row">
                      <div className="col col-6">
                        <div className="form-group">
                          <label>Monetization</label>
                          <select
                            className="form-control"
                            placeholder="Enter Publisher Name">
                            <option>Options</option>
                            <option>Options</option>
                            <option>Options</option>
                            <option>Options</option>
                          </select>
                        </div>
                      </div>

                      <div className="col" style={{ width: '100%' }}>
                        <div className="text-right">
                          <button
                            onClick={warningPopupclick(0)}
                            className="button"
                            type="submit">
                            Trigger Popup
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </WhiteBlock>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PopupBlock className={`${warningPopup === 0 ? 'show-popup' : ''}`}>
        <div className="popup-content">
          <button
            type="button"
            onClick={warningPopupclick(0)}
            className="close-popup">
            <svg
              className="cross-img"
              width="14"
              height="14"
              fill="none"
              viewBox="0 0 20 21">
              <path
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="1.636"
                d="M1 1.5l18 18M19 1.5l-18 18"
              />
            </svg>
          </button>

          <h3>
            You have unsaved changes. Would you like to save them before
            exiting?
          </h3>

          <div className="flex-row justify-flex-end no-margin">
            <button
              style={{ marginRight: 15 }}
              type="button"
              className="button light-red-button">
              Discard Changes
            </button>
            <button type="button" className="button">
              Save it
            </button>
          </div>
        </div>
      </PopupBlock>
    </Layout>
  );
};

export default Advertising;
